var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","large":_vm.large},on:{"click":_vm.$_onClick}},[_c('v-icon',[_vm._v(_vm._s(_vm.$_icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }